// Single source of truth reader for route SEO metadata.
// The data lives in route-metadata.json and is shared with the Express
// prerender middleware (seo-middleware/route-meta.js) and the build-time
// generator that writes public/index.html (scripts/generate-seo-ssot.js).
import routeMeta from "./route-metadata.json";

const normalize = (pathname) => {
  if (!pathname) return "/";
  const clean = pathname.replace(/\/+$/, "");
  return clean === "" ? "/" : clean;
};

// Returns { title, description, canonical, image, noindex } for a route, or
// null if the route is not registered in the SSOT.
export function getRouteMetadata(pathname) {
  const m = routeMeta[normalize(pathname)];
  if (!m) return null;
  return {
    title: m.title,
    description: m.description,
    canonical: m.canonical || normalize(pathname),
    image: m.ogImage || undefined,
    noindex: m.noindex === true,
  };
}

export default getRouteMetadata;
